import { render, staticRenderFns } from "./delivery-truckingfeeds.vue?vue&type=template&id=c8708d8e"
import script from "./delivery-truckingfeeds.vue?vue&type=script&lang=js"
export * from "./delivery-truckingfeeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports